/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SR_API_ACTION_GET_TENANT_ALERT_APPLICATION } from 'api/actionTypes';
import { getTenantAlertApplicationReports } from 'common/tenantAlertReportHelpers';

import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import ActivityIndicator from 'client/components/ActivityIndicator';
import SrText from 'client/components/SrText';

import branch from 'client/core/branch';
import withApiState from 'client/helpers/withApiState';
import HouseholdActions from 'client/actions/Household';

@withApiState({
  tenantAlertApplicationApiState: {
    action: SR_API_ACTION_GET_TENANT_ALERT_APPLICATION,
  },
})
@branch(({ tenantAlertReport }) => ({
  tenantAlertApplication: [
    'household',
    'tenantAlertApplicationById',
    tenantAlertReport.tenantAlertApplicationId,
  ],
}))
class SrTenantAlertApplicationViewer extends Component {
  static propTypes = {
    tenantAlertApplicationApiState: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    tenantAlertReport: PropTypes.object.isRequired,
    tenantAlertServiceId: PropTypes.number,
    user: PropTypes.object.isRequired,
    onUpdateHousehold: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  _onOpenModal = () => {
    const { dispatch, tenantAlertReport, onUpdateHousehold } = this.props;

    this.setState({
      isModalOpen: true,
    });

    dispatch(HouseholdActions.getTenantAlertApplication, {
      tenantAlertApplicationId: tenantAlertReport.tenantAlertApplicationId,
    }).then((tenantAlertApplication) => {
      if (
        tenantAlertReport.creditScore !== tenantAlertApplication.creditScore &&
        onUpdateHousehold
      ) {
        onUpdateHousehold();
      }
    });
  };

  _onCloseModal = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  render() {
    const { isModalOpen } = this.state;
    const {
      children,
      user,
      tenantAlertApplication,
      tenantAlertServiceId,
      tenantAlertApplicationApiState,
    } = this.props;

    let modalDOM = null;
    if (isModalOpen) {
      const reports = tenantAlertApplication
        ? getTenantAlertApplicationReports({ tenantAlertApplication, tenantAlertServiceId })
        : [];

      modalDOM = (
        <SrDarkModal className="SrTenantAlertApplicationViewer" onClose={this._onCloseModal}>
          <SrModalContent>
            <div className="viewerHeader">
              <SrText size="2xl" weight="medium">
                {user.name}
              </SrText>
            </div>
            <div className="reports">
              {tenantAlertApplicationApiState.inProgress && <ActivityIndicator />}
              {reports.map((report) => {
                return (
                  <div key={report.service_id} className="report">
                    <SrText size="2xl">{report.service_name}</SrText>
                    <div
                      className="reportContent"
                      dangerouslySetInnerHTML={{ __html: report.html.$ }}
                    />
                  </div>
                );
              })}
            </div>
          </SrModalContent>
        </SrDarkModal>
      );
    }

    return (
      <div className="inline">
        <div onClick={this._onOpenModal} className="inline">
          {children}
        </div>
        {modalDOM}
      </div>
    );
  }
}

SrTenantAlertApplicationViewer.displayName = 'SrTenantAlertApplicationViewer';

export default SrTenantAlertApplicationViewer;
